module.exports = __webpack_public_path__ + "static/media/david.5b4675bf.jpg";